import Link from "next/link";

const NavBarDoIt = () => {
  return (
    <div className="navbarDoIt-wrapper">
      <div className="navbarDoIt-container">
        <Link href={"/literasi-keuangan"}>
          <a>
            <p className="navbarDoIt-title">#DoITCERDAS</p>
          </a>
        </Link>
        <div className="navbarDoIt-link-container">
          <Link href={"/literasi-keuangan/cara-cerdas"}>
            <a className="navbarDoIt-link">Cara Cerdas</a>
          </Link>
        </div>
      </div>
      <NavStyle></NavStyle>
    </div>
  );
};

const NavStyle = () => {
  return (
    <style jsx>{`
      .navbarDoIt-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        border-bottom: solid 1px var(--color-gray-lighter);
        font-weight: bolder;
        background-color: var(--color-red);
        position: -webkit-sticky;
        position: sticky;
        top: 64px;
        z-index: 10;
      }
      .navbarDoIt-container {
        height: 64px;
        width: 100%;
        display: flex;
        align-items: center;
        max-width: 960px;
        margin-left: 30px;
      }
      .navbarDoIt-title {
        color: #ffffff;
        font-weight: bolder;
        font-size: 24px;
      }
      .navbarDoIt-link-container {
        display: flex;
        margin-left: 90px;
      }
      .navbarDoIt-link {
        color: #ffffff;
        font-weight: 500;
        font-size: 20px;
      }
      @media only screen and (max-width: 700px) {
        .navbarDoIt-container {
          display: flex;
          justify-content: space-between;
          margin-left: 10px;
        }
        .navbarDoIt-link-container {
          display: none;
        }
      }
    `}</style>
  );
};

export default NavBarDoIt;
